import { baseApi } from "../baseApi";
import { pick } from "../util";
import type { RateLimitConfig, UpdateRateLimitConfigInput } from "../types";

const RATE_LIMIT_FIELDS = `
  id
  enabled
  requests
  windowSeconds
  roleOverrides {
    role
    requests
    windowSeconds
  }
  createdAt
  updatedAt
`;

export const rateLimitApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Platform owner only — read the global rate-limit config.
    getRateLimitConfig: builder.query<RateLimitConfig, void>({
      query: () => ({
        body: {
          query: `
            query RateLimitConfig {
              rateLimitConfig {
                ${RATE_LIMIT_FIELDS}
              }
            }
          `,
        },
      }),

      transformResponse: (res: unknown) =>
        pick<RateLimitConfig>(res, "rateLimitConfig"),

      providesTags: [{ type: "RateLimit", id: "CONFIG" }],
    }),

    // Platform owner only — update the global rate-limit config.
    updateRateLimitConfig: builder.mutation<
      RateLimitConfig,
      UpdateRateLimitConfigInput
    >({
      query: (input) => ({
        body: {
          query: `
            mutation UpdateRateLimitConfig($input: UpdateRateLimitConfigInput!) {
              updateRateLimitConfig(input: $input) {
                ${RATE_LIMIT_FIELDS}
              }
            }
          `,
          variables: { input },
        },
      }),

      transformResponse: (res: unknown) =>
        pick<RateLimitConfig>(res, "updateRateLimitConfig"),

      invalidatesTags: [{ type: "RateLimit", id: "CONFIG" }],
    }),
  }),
});

export const { useGetRateLimitConfigQuery, useUpdateRateLimitConfigMutation } =
  rateLimitApi;
